import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute, useParams} from "@tanstack/react-router";
import {useRef} from "react";

import {Route as LeadRoute} from "./route";

export const Route = createFileRoute("/_app/sales/leads/$leadId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {leadId} = useParams({strict: false}) as {leadId: string};
  const {includeDeleted} = LeadRoute.useSearch();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate
        replace
        params={{leadId}}
        search={{
          includeDeleted,
          page: 1,
          perPage: 10,
          q: undefined,
          sortBy: "editedAt",
          sortDir: "desc",
        }}
        to={routes.sales.leads.lead().contacts()}
      />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
